
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 19 19","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.242.25c.352 0 .703.14 1.02.352.316.246.527.562.668.914.105.386.07.738-.07 1.09L12.144 17.23c-.176.352-.387.633-.668.774a1.67 1.67 0 01-.88.246c-.492 0-.878-.14-1.23-.457-.351-.281-.492-.703-.492-1.23v-6.188H2.687c-.597 0-1.054-.21-1.335-.633-.317-.422-.422-.914-.317-1.441.106-.528.422-.914.985-1.196L16.645.391c.175-.07.386-.141.597-.141zm-6.68 16.313l6.75-14.555-.07-.07-14.52 6.714c-.034.036-.034.07-.034.07l7.874-.034v7.874z"}})])
          )
        }
      }
    